import { createContext, type PropsWithChildren, use } from "react";

import { NoTouchPurchaseModal } from "app/components/no-touch-purchase-modal/NoTouchPurchaseModal";
import { useAddonsState } from "app/contexts/AddonStateContext/AddonStateContext";
import type { AddonTypeName } from "app/contexts/AddonStateContext/const";
import { useNoTouchPurchaseProvider } from "app/contexts/NoTouchPurchaseContext/useNoTouchPurchaseProvider";

export interface INoTouchPurchaseContext {
    handlePurchaseAddonClick: (addonType: AddonTypeName | null, quantity?: number, variation?: string) => void;
}

const defaultContextValue = {
    handlePurchaseAddonClick: () => {},
};

const NoTouchPurchaseContext = createContext<INoTouchPurchaseContext>(defaultContextValue);

export const NoTouchPurchaseProvider = ({ children }: PropsWithChildren) => {
    const { hasAddonsHub } = useAddonsState();
    const { contextValue, addonType, preselectQuantity, preselectVariation, setAddonType, handlePurchaseAddonClick } =
        useNoTouchPurchaseProvider();

    return (
        <NoTouchPurchaseContext.Provider value={contextValue}>
            {children}

            {hasAddonsHub ? (
                <NoTouchPurchaseModal
                    addonType={addonType}
                    preselectQuantity={preselectQuantity}
                    preselectVariation={preselectVariation}
                    setAddonType={setAddonType}
                    onPurchaseAddonClick={handlePurchaseAddonClick}
                />
            ) : null}
        </NoTouchPurchaseContext.Provider>
    );
};

export const useNoTouchPurchaseContext = () => use(NoTouchPurchaseContext);
